export enum MessageSendingStatus {
  SENT = "SENT",
  DELIVERED = "DELIVERED",
  ERROR = "ERROR"
}
